import { Injectable, inject } from '@angular/core';

import { LocalStoreService } from '@frontend/vanilla/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RtmsLocalStoreService {
    private localstorage = inject(LocalStoreService);

    get<T>(key: string): Observable<T> {
        return of(this.localstorage.get<T>(key)!);
    }

    set<T>(key: string, value: T): void {
        value ? this.localstorage.set(key, value) : this.localstorage.remove(key);
    }

    remove(key: string): void {
        this.localstorage.remove(key);
    }
}
